import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import RegistroLiterario from './Literario/Register/App';
import RegistroEventosPanel from './Eventos/Register/App';
import RegistroEventosPonencia from './Eventos/Register/AppPonencia';
import RegistroComposicion from './Composicion/Register/AppComposicion';
import Bases from './Literario/Bases';
import BasesMusica from './Musica/Bases';
import BasesComposicion from './Composicion/Bases'
import BasesEventos from './Eventos/Bases'
import TerminosComposicion from './Composicion/Politics'
import AdminBases from './Literario/Admin/AdminBasesResponsive';
import AdminPoliticsMusica from './Musica/Admin/AdminTerminosResponsive'
import AdminPoliticsComposicion from './Composicion/Admin/AdminTerminosResponsive'
import AdminBasesMusica from './Musica/Admin/AdminBasesResponsive';
import AdminBasesComposicion from './Composicion/Admin/AdminBasesResponsive';
import AdminPolitics from './Literario/Admin/AdminTerminosResponsive'
import AdminJuryProcess from './Literario/Admin/AdminJuryProcess'
import AdminJuryProcessMusica from './Musica/Admin/AdminJuryProcess'
import AdminJuryProcessComposicion from './Composicion/Admin/AdminJuryProcess'
import AdminLogs from './Literario/Admin/AdminLogs'
import HomeCasa from './Literario/Home';
import HomeMusica from './Musica/Home';
import HomeComposicion from './Composicion/Home';
import HomeEventos from './Eventos/Home';
import reportWebVitals from './reportWebVitals';
import Login from './Literario/Admin/AdminLogin';
import MusicaLogin from './Musica/Admin/AdminLogin';
import ComposicionLogin from './Composicion/Admin/AdminLogin';
import EventosLogin from './Eventos/Admin/AdminLogin';
import AdminJurado from './Literario/Admin/AdminJuryResponsive';
import AdminJuradoMusica from './Musica/Admin/AdminJuryResponsive';
import AdminJuradoComposicion from './Composicion/Admin/AdminJuryResponsive';
import JuryLogin from './Literario/Jury/JuryLogin';
import JuryPlaysList from './Literario/Jury/JuryPlays';
import JuryFinalPlays from './Literario/Jury/JuryFinalPlays';
import JuryPlaysListNot from './Literario/Jury/JuryPlaysPreselected ';
import JuryBases from './Literario/Jury/JuryBasesResponsive';
import JuryPolitics from './Literario/Jury/JuryTerminosResponsive'
import JuryHome from './Literario/Jury/Home';
import AdminHomeResponsive from './Literario/Admin/AdminHomeResponsive';
import AdminHomeResponsiveMusica from './Musica/Admin/AdminHomeResponsive';
import AdminHomeResponsiveComposicion from './Composicion/Admin/AdminHomeResponsive';
import AdminHomeResponsiveEventos from './Eventos/Admin/AdminHomeResponsive';
import Playslist from './Literario/Admin/PlaysListResponsive';
import PanelListEventos from './Eventos/Admin/PanelListResponsive';
import PonenciaListEventos from './Eventos/Admin/PonenciaListResponsive';
import PlayslistMusica from './Musica/Admin/PlaysListResponsive';
import PlayslistComposicion from './Composicion/Admin/PlaysListResponsive';
import ConcList from './Literario/Admin/ConcListResponsive'; 
import ConcListMusica from './Musica/Admin/ConcListResponsive';
import ConcListComposicion from './Composicion/Admin/ConcListResponsive';
import ConcListEventos from './Eventos/Admin/ConcListResponsive';
import Politics from './Literario/Politics'
import PoliticsMusica from './Musica/Politics'
import PoliticsEventos from './Eventos/Politics'
import {BrowserRouter, Switch, Route} from "react-router-dom";
import useToken from './useToken';
import Musica from './Musica/Register/AppMusica'
import Menu from './MenuResponsive'
import { Result,Button } from 'antd';
import JuryLoginMusica from './Musica/Jury/JuryLogin';
import JuryPlaysListMusica from './Musica/Jury/JuryPlays';
import JuryFinalPlaysMusica from './Musica/Jury/JuryFinalPlays';
import JuryPlaysListNotMusica from './Musica/Jury/JuryPlaysPreselected ';
import JuryBasesMusica from './Musica/Jury/JuryBasesResponsive';
import JuryPoliticsMusica from './Musica/Jury/JuryTerminosResponsive'
import './i18n';



const Routing = () => {
  const { token, setToken, getToken } = useToken();
  
  return(
    <div className='page-container'>
      <div className='content-wrap'>
      <BrowserRouter>
<Switch>
  
  <Route exact path='/'>
  <Menu />
  </Route>

  <Route exact path='/casa'>
    <HomeCasa/>
  </Route>
  <Route exact path='/musicologia'>
    <HomeMusica/>
  </Route>
  <Route exact path='/composicion'>
    <HomeComposicion/>
  </Route>

  <Route exact  path='/composicion/bases'>
    <BasesComposicion/>
  </Route>
  <Route exact  path='/composicion/terminos'>
    <TerminosComposicion/>
  </Route>

  <Route exact  path='/composicion/registro'>
  {!token && <ComposicionLogin setToken={setToken}/>}
    {(token ||getToken()) && <RegistroComposicion/>}
  </Route>

  <Route exact  path='/culturasOriginarias'>
    <HomeEventos/>
  </Route>
  <Route exact  path='/culturasOriginarias/registro/panel'>
    <RegistroEventosPanel/>
  </Route>
  <Route exact  path='/culturasOriginarias/registro/ponencia'>
    <RegistroEventosPonencia/>
  </Route>
  <Route exact  path='/culturasOriginarias/admin_pan'>
    <PanelListEventos/>
  </Route>
  <Route exact  path='/culturasOriginarias/admin_pon'>
    <PonenciaListEventos/>
  </Route>
  <Route exact  path='/culturasOriginarias/admin_conc'>
    <ConcListEventos/>
  </Route>
  <Route exact  path='/culturasOriginarias/bases'>
    <BasesEventos/>
  </Route>
  <Route exact  path='/culturasOriginarias/terminos'>
    <PoliticsEventos/>
  </Route>
  <Route exact path='/culturasOriginarias/admin'>
  {!token && <EventosLogin setToken={setToken}/>}
  {(token || getToken()) && <AdminHomeResponsiveEventos/>}
  </Route>
  
  <Route exact  path='/casa/registro'>
  {!token && <Login setToken={setToken}/>}
    {(token ||getToken()) && <RegistroLiterario/>}
  </Route>
  <Route exact path='/casa/admin'>
    {!token && <Login setToken={setToken}/>}
    {(token ||getToken()) && <AdminHomeResponsive/>}
  </Route>
  <Route exact path='/casa/jury_process'>
    {!token && <Login setToken={setToken}/>}
    {(token ||getToken()) && <AdminJuryProcess/>}
  </Route>
  <Route exact path='/casa/admin_logs'>
    {!token && <Login setToken={setToken}/>}
    {(token ||getToken()) && <AdminLogs/>}
  </Route>
  <Route exact path='/musicologia/registro'>
     <Musica/>
  </Route>
  <Route  exact path='/musicologia/bases'>
    <BasesMusica/>
  </Route>
  <Route exact path='/casa/bases'>
    <Bases/>
  </Route>



  <Route exact  path='/casa/admin_terminos'>
  {!token && <Login setToken={setToken}/>}
  {(token || getToken()) && <AdminPolitics/>}
  </Route>

  <Route exact  path='/casa/admin_bases'>
  {!token && <Login setToken={setToken}/>}
  {(token || getToken()) && <AdminBases/>}
  </Route>
    
  <Route exact path='/casa/admin_login'>
  {!token && <Login setToken={setToken}/>}
  {(token || getToken()) && <AdminHomeResponsive/>}
  </Route>
  
  <Route exact path='/casa/terminos'>
    <Politics/>
  </Route>
 
  
  <Route exact path='/casa/admin_plays_list'>
    {!token && <Login setToken={setToken}/>}
    {(token ||getToken()) &&<Playslist/>}
  </Route>
  
  <Route exact path='/casa/admin_conc_list'>
    {!token && <Login setToken={setToken}/>}
    {(token ||getToken()) &&   <ConcList/>}
  </Route>
  <Route exact path='/casa/admin_jurado'>
    {!token && <Login setToken={setToken}/>}
    {(token ||getToken()) &&  <AdminJurado juryType ="all"/>}
     
  </Route>
  <Route exact path='/casa/admin_jurado_cuent'>
    {!token && <Login setToken={setToken}/>}
    {(token ||getToken()) &&  <AdminJurado juryType ="Novela"/>}
     
  </Route>
  <Route exact  path='/casa/admin_jurado_lit'>
    {!token && <Login setToken={setToken}/>}
    {(token ||getToken()) &&  <AdminJurado juryType ="Literatura para niños y jóvenes"/>}
     
  </Route>
  <Route exact path='/casa/admin_jurado_br'>
    {!token && <Login setToken={setToken}/>}
    {(token ||getToken()) &&  <AdminJurado juryType ="Ensayo de tema artístico-literario"/>}
     
  </Route>
  <Route exact path='/casa/admin_jurado_negr'>
    {!token && <Login setToken={setToken}/>}
    {(token ||getToken()) &&  <AdminJurado juryType ="Teatro"/>}
     
  </Route>

  <Route exact  path='/casa/jurado_login'>
    {!token && <JuryLogin setToken={setToken}/>}
    {(token ||getToken()) &&   <ConcList/>}
  </Route>
  <Route exact path='/casa/jurado_obras'>
    {!token && <JuryLogin setToken={setToken}/>}
    {(token ||getToken()) &&   <JuryPlaysList/>}
  </Route> 
  <Route exact path='/casa/jurado_obras_preseleccionadas'>
    {!token && <JuryLogin setToken={setToken}/>}
    {(token ||getToken()) &&   <JuryPlaysListNot/>}
  </Route>
  <Route exact path='/casa/jurado_obras_finalistas'>
    {!token && <JuryLogin setToken={setToken}/>}
    {(token ||getToken()) && <JuryFinalPlays/>}
  </Route>
  <Route exact path='/casa/jurado'>
    {!token && <JuryLogin setToken={setToken}/>}
    {(token ||getToken()) &&   <JuryHome/>}
  </Route>
  <Route exact path='/casa/jury_bases'>
    {!token && <JuryLogin setToken={setToken}/>}
    {(token ||getToken()) &&   <JuryBases/>}
  </Route>
  <Route exact path='/casa/jury_terminos'>
    {!token && <JuryLogin setToken={setToken}/>}
    {(token ||getToken()) &&   <JuryPolitics/>}
  </Route>




  <Route exact  path='/musicologia/jurado_login'>
    {!token && <JuryLoginMusica setToken={setToken}/>}
    {(token ||getToken()) &&   <JuryPlaysListMusica/>}
  </Route>
  <Route exact path='/musicologia/jurado_obras'>
    {!token && <JuryLoginMusica setToken={setToken}/>}
    {(token ||getToken()) &&   <JuryPlaysListMusica/>}
  </Route> 
  <Route exact path='/musicologia/jurado_obras_preseleccionadas'>
    {!token && <JuryLoginMusica setToken={setToken}/>}
    {(token ||getToken()) &&   <JuryPlaysListNotMusica/>}
  </Route>
  <Route exact path='/musicologia/jurado_obras_finalistas'>
    {!token && <JuryLoginMusica setToken={setToken}/>}
    {(token ||getToken()) && <JuryFinalPlaysMusica/>}
  </Route>
  <Route exact path='/musicologia/jurado'>
    {!token && <JuryLoginMusica setToken={setToken}/>}
    {(token ||getToken()) &&   <JuryPlaysListMusica/>}
  </Route>
  <Route exact path='/musicologia/jury_bases'>
    {!token && <JuryLoginMusica setToken={setToken}/>}
    {(token ||getToken()) &&   <JuryBasesMusica/>}
  </Route>
  <Route exact path='/musicologia/jury_terminos'>
    {!token && <JuryLoginMusica setToken={setToken}/>}
    {(token ||getToken()) &&   <JuryPoliticsMusica/>}
  </Route>











  <Route exact path='/musicologia/admin_terminos'>
  {!token && <MusicaLogin setToken={setToken}/>}
  {(token || getToken()) && <AdminPoliticsMusica/>}
  </Route>

  <Route exact path='/musicologia/admin_bases'>
  {!token && <MusicaLogin setToken={setToken}/>}
  {(token || getToken()) && <AdminBasesMusica/>}
  </Route>
    
  <Route exact path='/musicologia/admin_login'>
  {!token && <MusicaLogin setToken={setToken}/>}
  {(token || getToken()) && <AdminHomeResponsiveMusica/>}
  </Route>

  <Route exact path='/composicion/admin_terminos'>
  {!token && <ComposicionLogin setToken={setToken}/>}
  {(token || getToken()) && <AdminPoliticsComposicion/>}
  </Route>

  <Route exact path='/composicion/admin_bases'>
  {!token && <ComposicionLogin setToken={setToken}/>}
  {(token || getToken()) && <AdminBasesComposicion/>}
  </Route>
    
  <Route exact path='/composicion/admin_login'>
  {!token && <ComposicionLogin setToken={setToken}/>}
  {(token || getToken()) && <AdminHomeResponsiveComposicion/>}
  </Route>
  
  <Route exact path='/musicologia/terminos'>
    <PoliticsMusica/>
  </Route>
 
  <Route  exact path='/musicologia/admin'>
    {!token && <MusicaLogin setToken={setToken}/>}
    {(token ||getToken()) && <AdminHomeResponsiveMusica/>}
  </Route>
  <Route exact path='/musicologia/admin_plays_list'>
    {!token && <MusicaLogin setToken={setToken}/>}
    {(token ||getToken()) &&<PlayslistMusica/>}
  </Route>
  
  <Route exact path='/musicologia/admin_conc_list'>
    {!token && <MusicaLogin setToken={setToken}/>}
    {(token ||getToken()) &&   <ConcListMusica/>}
  </Route>
  <Route exact path='/musicologia/admin_jurado'>
    {!token && <MusicaLogin setToken={setToken}/>}
    {(token ||getToken()) &&  <AdminJuradoMusica juryType ="all"/>}
     
  </Route>


  <Route  exact path='/composicion/admin'>
    {!token && <ComposicionLogin setToken={setToken}/>}
    {(token ||getToken()) && <AdminHomeResponsiveComposicion/>}
  </Route>
  <Route exact path='/composicion/admin_plays_list'>
    {!token && <ComposicionLogin setToken={setToken}/>}
    {(token ||getToken()) &&<PlayslistComposicion/>}
  </Route>
  
  <Route exact path='/composicion/admin_conc_list'>
    {!token && <ComposicionLogin setToken={setToken}/>}
    {(token ||getToken()) &&   <ConcListComposicion/>}
  </Route>
  <Route exact path='/composicion/admin_jurado'>
    {!token && <ComposicionLogin setToken={setToken}/>}
    {(token ||getToken()) &&  <AdminJuradoComposicion juryType ="all"/>}
     
  </Route>

  <Route exact path='/musicologia/jury_process'>
    {!token && <MusicaLogin setToken={setToken}/>}
    {(token ||getToken()) && <AdminJuryProcessMusica/>}
  </Route>
  
 
  <Route path='/casa'>
    <Result
        status="404"
        title="404"
        subTitle="Lo sentimos,la página visitada no existe."
        extra={<Button onClick={()=>window.open("/casa","_self")} type="primary">Regresar a la página inicial</Button>}
      />
  </Route>
  <Route path='/musicologia'>
    <Result
        status="404"
        title="404"
        subTitle="Lo sentimos,la página visitada no existe."
        extra={<Button onClick={()=>window.open("/musicologia","_self")} type="primary">Regresar a la página inicial</Button>}
      />
  </Route>

  <Route path='/composicion'>
    <Result
        status="404"
        title="404"
        subTitle="Lo sentimos,la página visitada no existe."
        extra={<Button onClick={()=>window.open("/composicion","_self")} type="primary">Regresar a la página inicial</Button>}
      />
  </Route>

<Route>
  <Result
      status="404"
      title="404"
      subTitle="Lo sentimos,la página visitada no existe."
      extra={<Button onClick={()=>window.open("/","_self")} type="primary">Regresar a la página inicial</Button>}
    />
</Route>
  
</Switch>
    </BrowserRouter>
      </div>
      
    </div>
    
  )
}


ReactDOM.render(

  
  <React.StrictMode>
    <Routing />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
